var map = {
	"./autoglyphs-back.svg": 1004,
	"./autoglyphs.svg": 1005,
	"./axies-back.svg": 1006,
	"./axies.svg": 1007,
	"./blanknft-back.svg": 1008,
	"./blanknft.svg": 1009,
	"./bounties.svg": 1010,
	"./clovers-back.svg": 1011,
	"./clovers.svg": 1012,
	"./cryptokitties-back.svg": 1013,
	"./cryptokitties.svg": 1014,
	"./cryptopunks-back.svg": 1015,
	"./cryptopunks.svg": 1016,
	"./cryptovoxels-back.svg": 1017,
	"./cryptovoxels.svg": 1018,
	"./decentralands-back.svg": 1019,
	"./decentralands.svg": 1020,
	"./default.svg": 303,
	"./empty.svg": 1021,
	"./godunchained.svg": 1022,
	"./knownoriginv1-back.svg": 1023,
	"./knownoriginv1.svg": 1024,
	"./knownoriginv2-back.svg": 1025,
	"./knownoriginv2.svg": 1026,
	"./makersplaces-back.svg": 1027,
	"./makersplaces.svg": 1028,
	"./makersplacev2-back.svg": 1029,
	"./makersplacev2.svg": 1030,
	"./makersplacev3-back.svg": 1031,
	"./makersplacev3.svg": 1032,
	"./mycryptoheros-back.svg": 1033,
	"./mycryptoheros.svg": 1034,
	"./mywork.svg": 1035,
	"./new-collection-back.svg": 1036,
	"./new-collection.svg": 1037,
	"./new.svg": 1038,
	"./superrarev1-back.svg": 1039,
	"./superrarev1.svg": 1040,
	"./superrarev2-back.svg": 1041,
	"./superrarev2.svg": 1042,
	"./wrappedpunks-back.svg": 1043,
	"./wrappedpunks.svg": 1044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1003;